<template>
  <div class='menu'>
    <nav>
      <ul>
        <li  @click.prevent="selectMenu('menu0')">
          <router-link to="/home" :class="{ active: isActive('/home') }">首页</router-link>
        </li>
        <li  @click.prevent="selectMenu('menu1')">
          <router-link to="/about" :class="{ active: isActive('/about') }" >关于我们</router-link>
        </li>
        <li   @click.prevent="selectMenu('menu2')">
          <router-link to="/products" :class="{ active: isActive('/products') }">产品中心</router-link>
        </li>
        <li>
          <router-link to="/">解决方案</router-link>
        </li>
        <li>
          <router-link to="/">新闻中心</router-link>
        </li>
        <li>
          <router-link to="/">服务支持</router-link>
        </li>
        <li  @click.prevent="selectMenu('menu0')">
          <router-link to="/contact" :class="{ active: isActive('/contact') }">联系我们</router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  methods: {
    selectMenu(menuItem) {
      this.$emit('menu-selected', menuItem);
    },
    isActive(path) {
      // 检查是否有匹配的路由记录，这个只能匹配该路由，但要以这个路由开头的就不行了要用下面的方法——ym1573
      // return this.$route.path === path;
      // 检查是否有匹配的路由记录是以给定路径开头的
      return this.$route.matched.some(record => record.path.startsWith(path));
    },

  }
};
</script>

<style>
.menu {

}
.menu li {
  display: inline;
  /* 让列表项水平显示 */
  margin-right: 1.875vw;
  /* 添加一些右边距，使菜单项之间有间隔 */
  position: relative;
  /* 设置定位，以便横线位于文字下方 */
}
.menu li a {
}
.menu li .active:after {
  content: '';
  /* 使用伪元素添加横线 */
  position: absolute;
  /* 设置绝对定位 */
  left: 40%;
  /* 横线的左边与文字对齐 */
  bottom: 0;
  /* 横线的底部与文字对齐 */
  width: 20%;
  /* 横线的宽度 */
  height: 0.375vw;
  /* 横线的高度 */
  background: #fff;
  /* 横线的颜色 */
  transition: background-color 0.3s;
  /* 可选：为横线添加过渡效果 */
}

/* 可选：鼠标悬浮时改变横线颜色 */
.menu li:hover {
  background: rgba(255, 255, 255, .2);
  transition: background-color 0.3s;
  /* 可选：为横线添加过渡效果 */
}

.menu ul {
  margin: 0.9375vw auto;
  flex-grow: 1;
  font-size: 4vw;
  display: flex;
}

.menu ul li {
  flex-grow: 1;
}

@media (max-width: 767px) {
  /* 在这里添加针对手机屏幕的样式 */
  .menu {
    display: none;
  }

}

@media (min-width: 768px) {
  .menu {
    visibility: visible;

  }
  .menu ul {
    margin: 5px auto;
    font-size: 18px;
  }
  .menu li .active:after {
    height: 2px;
    /* 横线的高度 */
  }
}

@media (min-width: 992px) {
  .menu ul {
    font-size: 20px;
  }

}

@media (min-width: 1200px) {


}
</style>